import React, { useEffect, useState, useRef } from 'react';
import ball from '@/assets/background/ball.png';
import styles from './index.less';

/** 相互碰撞的透明小球组件 */
export default ({ param, index: id  }) => {
  const [activeIndex, setActiveIndex] = useState(false);

  return (
    <div style={{ flex: 1, position: 'relative', display: 'flex', justifyContent: 'center'}}>
        <div className={`${styles.ball_item} ${styles[`ball_item${id}`]} ${activeIndex ? '': styles[`animation${id}`]}`}
          style={activeIndex ? {}: {background: `url(${ball}) no-repeat center / 100% 100%`}}
          onMouseEnter={()=> setActiveIndex(true)}
          onMouseLeave={()=> setActiveIndex(false)}
        >
          <a href={param.url} target="_blank">
            <p>{param.title}</p>
            <div><span>{param.text}</span></div>
          </a>
          {/** hover 内容 */}
          { param.desc && <div className={styles.popover} style={{ display: activeIndex ? 'block': 'none' }}>{param.desc}</div>}
        </div>
      
    </div>
  )
}
